module.exports = {"451029100":"乐里镇","451029101":"旧州镇","451029102":"定安镇","451029103":"六隆镇","451029104":"浪平镇","451029200":"潞城瑶族乡","451029201":"利周瑶族乡","451029202":"平塘乡","451029204":"八桂瑶族乡","451029205":"八渡瑶族乡","451029206":"那比乡","451029207":"高龙乡","451029208":"百乐乡","451029209":"者苗乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451029.json
// module id = 2149
// module chunks = 0